import { Locale } from "./Locale.mjs";
import { supportedLocales } from "./supportedLocales.mjs";
export function isLocaleSupported(code) {
  try {
    return supportedLocales.includes(Locale.from(code).isoCode);
  } catch (_unused) {
    return false;
  }
}